import { company_01, company_02, company_03, company_04, company_05, company_06, company_07, company_08, company_09, company_10 } from "../../_components/Imagepath";

export default {
  domaindata: [
    {
      "id": "1", "img": company_01,
      "Name": "Hermann Groups",
      "DomainURL": "hru.example.com",
      "Plan": "Advanced (Monthly)",
      "RegisteredOn": "19 Jan 2024",
      "Status": "Approved",
      "Action":
        "Domain Detail\n                              \n                            \n                            \n                              \n                                \n                                  \n                                  Delete",
    },
    {
      "id": "2",
 "img": company_02,
      "Name": "Skiles LLC",
      "DomainURL": "sk.example.com",
      "Plan": "Basic  (Yearly)",
      "RegisteredOn": "19 Jan 2024",
      "Status": "Pending",
      "Action":
        "Domain Detail\n                              \n                            \n                            \n                              \n                                \n                                  \n                                  Delete",
    },
    {
      "id": "3",
 "img": company_03,
      "Name": "Kerluke Group",
      "DomainURL": "kerluke.example.com",
      "Plan": "Basic  (Yearly)",
      "RegisteredOn": "19 Jan 2024",
      "Status": "Rejected",
      "Action":
        "Domain Detail\n                              \n                            \n                            \n                              \n                                \n                                  \n                                  Delete",
    },
    {
      "id": "4",
"img": company_04,
      "Name": "Schowalter Group",
      "DomainURL": "schowalter.example.com",
      "Plan": "Advanced (Monthly)",
      "RegisteredOn": "19 Jan 2024",
      "Status": "Pending",
      "Action":
        "Domain Detail\n                              \n                            \n                            \n                              \n                                \n                                  \n                                  Delete",
    },
    {
      "id": "5",
 "img": company_05,
      "Name": "Accentric Global",
      "DomainURL": "accentric.example.com",
      "Plan": "Basic  (Yearly)",
      "RegisteredOn": "19 Jan 2024",
      "Status": "Pending",
      "Action":
        "Domain Detail\n                              \n                            \n                            \n                              \n                                \n                                  \n                                  Delete",
    },
    {
      "id": "6",
 "img": company_06,
      "Name": "Dexter Matrix",
      "DomainURL": "dexter.example.com",
      "Plan": "Advanced (Monthly)",
      "RegisteredOn": "19 Jan 2024",
      "Status": "Pending",
      "Action":
        "Domain Detail\n                              \n                            \n                            \n                              \n                                \n                                  \n                                  Delete",
    },
    {
      "id": "7",
 "img": company_07,
      "Name": "Emporis Technologies",
      "DomainURL": "emporis.example.com",
      "Plan": "Basic  (Yearly)",
      "RegisteredOn": "19 Jan 2024",
      "Status": "Pending",
      "Action":
        "Domain Detail\n                              \n                            \n                            \n                              \n                                \n                                  \n                                  Delete",
    },
    {
      "id": "8",
 "img": company_08,
      "Name": "Beacon Softwares",
      "DomainURL": "beacon.example.com",
      "Plan": "Advanced (Monthly)",
      "RegisteredOn": "19 Jan 2024",
      "Status": "Pending",
      "Action":
        "Domain Detail\n                              \n                            \n                            \n                              \n                                \n                                  \n                                  Delete",
    },
    {
      "id": "9",
"img": company_09,
      "Name": "Global tech",
      "DomainURL": "global.example.com",
      "Plan": "Basic  (Yearly)",
      "RegisteredOn": "19 Jan 2024",
      "Status": "Pending",
      "Action":
        "Domain Detail\n                              \n                            \n                            \n                              \n                                \n                                  \n                                  Delete",
    },
    {
      "id": "10",
 "img": company_10,
      "Name": "High Tech Lead",
      "DomainURL": "high.example.com",
      "Plan": "Basic  (Yearly)",
      "RegisteredOn": "19 Jan 2024",
      "Status": "Pending",
      "Action":
        "Domain Detail\n                              \n                            \n                            \n                              \n                                \n                                  \n                                  Delete",
    },
  ],
};
